import React from 'react';
import { MatchingEntity } from '../../types/index';
import { CustomSider } from '../../components/layout/CustomSider';
import { Button, Row } from 'antd';
import { SectionSubTitle } from '../../components/text/Titles';
import { Section } from '../../components/Section';

type Props = {
  matchings: MatchingEntity[];
  handleClick: (id: MatchingEntity) => any;
  selectedMatching: MatchingEntity | null;
};

export const MiniSidebar = ({ matchings, handleClick, selectedMatching }: Props) => {
  return (
    <CustomSider width="240px" style={{ background: '#fff', borderRight: '1px solid #c2c2c2', paddingTop: '1.25rem' }}>
      <Section>
        <SectionSubTitle>Documents in this run</SectionSubTitle>
      </Section>
      <Row className="w-full flex flex-col">
        {matchings.map(documentMatch => {
          return (
            <div key={documentMatch.id} className="w-full mx-auto my-0 py-1.5">
              <Button
                type="text"
                onClick={() => {
                  handleClick(documentMatch);
                }}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  fontWeight: documentMatch.id === selectedMatching?.id ? 'bold' : 'normal',
                }}>
                {documentMatch.id}
              </Button>
            </div>
          );
        })}
      </Row>
    </CustomSider>
  );
};
